import React, { Component, useEffect, useState } from "react";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import FlipMove from "react-flip-move";

const SortableContainer = sortableContainer(
    ({ children }: { children: Component }) => {
        return (
            <FlipMove>
                <div>{children}</div>
            </FlipMove>
        );
    },
);

function arrayMove(x: any[], from: number, to: number) {
    x.splice(to < 0 ? x.length + to : to, 0, x.splice(from, 1)[0]);
}

const Icon = () => (
    <div className="w-6 h-6 mr-2 rounded-full ">
        <img
            src={"/assets/images/drag_indicator.svg"}
            alt=" | "
            className="object-contain w-full h-full"
        />
    </div>
);

const DraggableList = (props: any) => {
    const { items, itemBuilder, onSortEnd, reset, disabled } = props;
    const [order, setOrder] = useState(
        [...Array(items.length)].map((i, idx) => idx),
    );

    useEffect(() => {
        if (reset) setOrder(reset);
    }, [reset]);

    const SortableItem = sortableElement(({ data }: { data: any }) => (
        <div
            className={`flex flex-row ${
                disabled ? "px-8" : "pr-8"
            } sortable-item`}
        >
            <div className="flex-9 mt-3 py-4">{!disabled && <Icon />}</div>
            <div className="flex-1">{itemBuilder(data.value, data.index)}</div>
        </div>
    ));

    const handleSortEnd = ({
        oldIndex,
        newIndex,
    }: {
        newIndex: number;
        oldIndex: number;
    }) => {
        const newOrder = [...order];
        arrayMove(newOrder, oldIndex, newIndex);
        setOrder(newOrder);
        onSortEnd(newOrder);
    };

    return (
        <div className="noselect">
            <SortableContainer onSortEnd={handleSortEnd} pressDelay={200}>
                {order.map((value, index) => (
                    <SortableItem
                        disabled={disabled}
                        key={`item-${items[value]}`}
                        index={index}
                        data={{ value: items[value], index }}
                    />
                ))}
            </SortableContainer>
        </div>
    );
};

export default DraggableList;
